import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from './utils/utils';
import { Constants } from '../model/constants';
import { ChangePwdModel } from '../model/changepwdmodel';
import { User } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient) { }

    getUser(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'user/user';
        return this.http.get(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    updateUser(user: User): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'user/update';
        return this.http.put(
            Utils.setHost(Constants.API_ENDPOINT, url),
            JSON.stringify(user),
            {headers}
        );
    }

    changePassword(requestModel: ChangePwdModel): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'user/changepwd';
        return this.http.put(
            Utils.setHost(Constants.API_ENDPOINT, url),
            JSON.stringify(requestModel),
            {headers}
        );
    }
    
}
